const TimelineCheckpointIcon = ({ index, rightGradientColor, leftGradientColor, label }) => (
  <svg
    width={385}
    height={198}
    viewBox="0 0 385 198"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginLeft: -26 }}
  >
    <line x1={47} y1={100} x2={149} y2={100} stroke="#081F43" strokeWidth={2} />
    <circle cx={24} cy={99} r={12} fill={leftGradientColor || "#D62F99"} />
    <circle cx={24} cy={99} r={23} stroke="#081F43" strokeWidth={2} />
    <path
      d="M145 99.9997C175.935 85.8437 186.523 73.3454 195 60L195 138C183.934 119.24 170.305 111.671 145 99.9997Z"
      fill={leftGradientColor || "#E32F90"}
    />

    <circle cx={286} cy={99} r={85} stroke={`url(#paint0_linear_433_275_index-${index})`} strokeWidth={28} />

    {label && (
      <text
        x={286}
        y={101}
        textAnchor="middle"
        dominantBaseline="middle"
        fill={"#081F43"}
        style={{ fontSize: "40px", fontWeight: 600 }}
      >
        {label}
      </text>
    )}

    <defs>
      <linearGradient
        id={`paint0_linear_433_275_index-${index}`}
        x1={187}
        y1={99}
        x2={385}
        y2={99}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={leftGradientColor || "#E22D94"} />
        <stop offset={1} stopColor={rightGradientColor || "#FE5F00"} />
      </linearGradient>
    </defs>
  </svg>
);

export default TimelineCheckpointIcon;
